import * as React from 'react'
import { Spin } from 'antd'

export default () => {
    return(
      <div style={{
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Spin size={'default'}/>
      </div>
    )
}
